import { Text, useTranslation } from '@weareconceptstudio/core';

const StyledQuotedText = ({ text }) => {
	const { translate } = useTranslation();

	const parts = text.split(/(".*?")/).filter((part) => part !== '');

	return parts.map((part, index) => {
		if (part.startsWith('"') && part.endsWith('"')) {
			const cleanText = part.slice(1, -1);

			let wordsAndSpaces = cleanText.split(/(\s+)/).filter((item) => item !== '');
			if (wordsAndSpaces.length == 1) {
				wordsAndSpaces = translate(cleanText)
					.split(/(\s+)/)
					.filter((item) => item !== '');
			}

			return wordsAndSpaces.map((item, itemIndex) => (
				<Text
					key={`${index}-${itemIndex}`}
					tag={'span'}
					className={`h2 font-larken-light-italic green-1000 styled-text`}
					text={item}
				/>
			));
		} else {
			let wordsAndSpaces = part.split(/(\s+)/).filter((item) => item !== '');
			if (wordsAndSpaces.length == 1) {
				wordsAndSpaces = translate(part)
					.split(/(\s+)/)
					.filter((item) => item !== '');
			}
			return wordsAndSpaces.map((item, itemIndex) => (
				<Text
					key={`${index}-${itemIndex}`}
					tag={'span'}
					className={`h2 font-larken-light green-1000 normal-text`}
					text={item}
				/>
			));
		}
	});
};

export default StyledQuotedText;
